var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.4141 11.9998L17.7071 7.70676C18.0981 7.31576 18.0981 6.68376 17.7071 6.29276C17.3161 5.90176 16.6841 5.90176 16.2931 6.29276L12.0001 10.5858L7.7071 6.29276C7.3161 5.90176 6.6841 5.90176 6.2931 6.29276C5.9021 6.68376 5.9021 7.31576 6.2931 7.70676L10.5861 11.9998L6.2931 16.2928C5.9021 16.6838 5.9021 17.3158 6.2931 17.7068C6.4881 17.9018 6.7441 17.9998 7.0001 17.9998C7.2561 17.9998 7.5121 17.9018 7.7071 17.7068L12.0001 13.4138L16.2931 17.7068C16.4881 17.9018 16.7441 17.9998 17.0001 17.9998C17.2561 17.9998 17.5121 17.9018 17.7071 17.7068C18.0981 17.3158 18.0981 16.6838 17.7071 16.2928L13.4141 11.9998Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/Close.727fa5fa0d2d3dd671d5bdab8b9389a3.svg";
export { ForwardRef as ReactComponent };